import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const bookingBulkVoidAtom = createMutationAtomFactory(
  'trade.bookingBulkVoid',
  (params: { ids: string[]; forceUnlink?: boolean }) => ({
    tradeBookingBulkVoid: {
      __args: {
        input: {
          ids: params.ids,
          forceUnlink: params.forceUnlink,
        },
      },
      results: {
        booking: {
          id: true,
          documentNumber: true,
          status: true,
        },
        blockingLoads: {
          id: true,
          documentNumber: true,
          status: true,
        },
        unlinkableLoads: {
          id: true,
          documentNumber: true,
          status: true,
        },
        requiresConfirmation: true,
      },
      successCount: true,
      failedCount: true,
    },
  }),
);
